import { Route, Routes } from '@angular/router';
import { AppLayoutData } from '@spotter/components/layout/app-layout/app-layout.component';
import { LoggedInGuard } from '@spotter/guards/login-guard';
import { setupRoutes } from '@spotter/providers/spotter-providers';


const appLayoutData: AppLayoutData = {
    site: 'tracker',
    sidebarLayout: {
        sections: [
            {
                title: "tracker.sidebar.headers.explore", accessRights: 'public', translate: true,
                items: [
                    { id: 'map', routerLink: '/map', title: "tracker.sidebar.map", icon: 'map', translate: true },
                    { id: 'grid', routerLink: '/grid', title: "tracker.sidebar.grid", icon: 'table-cells-large', translate: true },
                    { id: 'upload', routerLink: '/upload', title: "tracker.sidebar.upload", icon: 'upload', translate: true },
                    { id: 'download', routerLink: '/download', title: "tracker.sidebar.download", icon: 'download', translate: true },
                ]
            }
        ]
    }
}

const appRoutes: Routes = [
    { path: '', loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage) },
    { path: 'map', loadComponent: () => import('./pages/map/map.page').then(m => m.MapPage) },
    { path: 'grid', loadComponent: () => import('./pages/grid/grid.page').then(m => m.GridPage) },
    { path: 'download', loadComponent: () => import('./pages/download/download.page').then(m => m.DownloadPage) },

    { path: 'meadow/:id', loadComponent: () => import('./pages/meadows/meadow/meadow.page').then(m => m.MeadowPage) },
    { path: 'meadow/:id/vector-map', loadComponent: () => import('./pages/meadows/meadow-vector/meadow-vector.page').then(m => m.MeadowVectorPage) },
    {
        path: 'meadow/:id/add-attachment', canActivate: [LoggedInGuard],
        loadComponent: () => import('./pages/meadows/attachment/attachment.page').then(m => m.AttachmentPage)
    },
    {
        path: 'meadow/:id/edit',
        canActivate: [LoggedInGuard],
        loadComponent: () => import('./pages/meadows/upload/add-data/add-data.page').then(m => m.AddDataPage),
    },
    {
        path: 'upload', canActivate: [LoggedInGuard],
        loadComponent: () => import('./pages/meadows/upload-meadow/upload-meadow.page').then(m => m.UploadMeadowPage),
    },
    {
        path: 'upload/:id/confirm-shapefile', canActivate: [LoggedInGuard],
        loadComponent: () => import('./pages/meadows/upload/confirm-shapefile/confirm-shapefile.page').then(m => m.ConfirmShapefilePage),
    },
    {
        path: 'upload/:id/add-data', canActivate: [LoggedInGuard],
        loadComponent: () => import('./pages/meadows/upload/add-data/add-data.page').then(m => m.AddDataPage),
    },

    { path: 'profile/dashboard', loadComponent: () => import('./pages/profile/profile.page').then(m => m.ProfilePage) },
];

const standaloneRoutes: Routes = [
    {
        path: 'helpers/meadow-map-thumbnail/:id',
        loadComponent: () => import('./pages/helpers/meadow-map-thumbnail/meadow-map-thumbnail.page')
            .then(m => m.MeadowMapThumbnailPage)
    }
];


export const routes: Routes = setupRoutes(appRoutes, appLayoutData, standaloneRoutes);